import { SUBMIT, SUBMIT_SUCCESS, SUBMIT_ERROR } from './constants';

/**
 * Submit
 */
export function submit(data, query) {
  return {
    type: SUBMIT,
    data,
    query,
  };
}

export function submitSuccess(response) {
  return {
    type: SUBMIT_SUCCESS,
    response,
  };
}

export function submitError(error) {
  return {
    type: SUBMIT_ERROR,
    error,
  };
}
